<div ngbDropdown>
  <div ngbDropdownToggle
       role="button">
    Location:
    @if (location(); as location) {
      <b>{{ location.HotelCode }}</b>
    } @else {
      <b>Select</b>
    }
  </div>

  <div ngbDropdownMenu>
    <a ngbDropdownItem
       (click)="openAddLocationModal()"> Add location </a>

    @if (location()) {
      <div>
        @for (location of locations(); track location) {
          <a ngbDropdownItem
             [routerLink]="['/', 'virtual-room', 'locations', location.HotelCode]">
            {{ location.HotelCode }}
          </a>
        }
      </div>
    } @else {
      @for (location of locations(); track location) {
        <a ngbDropdownItem
           [routerLink]="[location.HotelCode]">
          {{ location.HotelCode }}
        </a>
      }
    }
  </div>
</div>